import 'antd/lib/form/style';
//# sourceMappingURL=index.js.map